/**
 * Namespace `credentialHistory` — HQ-2026-013 · ADR-007: lịch sử phiên bản của bộ thông số, so sánh, khôi phục, ân hạn
 * khi sửa khoá, tự chạy thử sau khi lưu. Bản gốc tiếng Việt.
 */
export const credentialHistory = {
  title: "Lịch sử phiên bản",
  subtitle: "Bộ « {name} » · {product} · {env}",
  intro:
    "Mỗi lần lưu, khôi phục hay xoá, hub giữ lại phiên bản cũ (không sửa, không xoá được). Khôi phục là ghi một phiên bản MỚI chép nội dung cũ — lịch sử không mất. Trường bí mật không bao giờ hiện giá trị, chỉ gợi ý vài ký tự cuối.",
  back: "← Tích hợp",
  loading: "Đang tải…",
  notFound: "Không tìm thấy bộ thông số này (có thể đã bị xoá).",
  loadFailed: "Không tải được lịch sử: {error}",
  readOnlyRole: "Bạn chỉ có quyền xem — không khôi phục hay cắt ân hạn được.",
  reload: "Tải lại",

  versionsTitle: "Các phiên bản",
  colRevision: "Phiên bản",
  colAuthor: "Tạo bởi",
  colTest: "Chạy thử",
  colReplaced: "Bị thay bởi",
  colSecrets: "Trường bí mật đổi",
  colInbound: "Tin đối tác đẩy tới",
  current: "hiện hành",
  unknownAuthor: "không rõ",
  "kind.update": "Sửa",
  "kind.restore": "Khôi phục #{from}",
  "kind.delete": "Xoá bộ",
  note: "« {note} »",
  redacted: "đã che nội dung",
  "inbound.current": "Đang dùng",
  "inbound.grace": "Còn được nhận đến {when}",
  "inbound.capped": "Quá trần {max} phiên bản — không được nhận",
  "inbound.expired": "Hết ân hạn",
  "inbound.cut": "Đã cắt ân hạn",
  "inbound.none": "—",
  inboundNoneTitle: "Lượt thay không đổi trường bí mật nên không có khoá cũ nào để nhận.",

  bindingsTitle: "Đang gán",
  bindingsNone: "Chưa gán cho app nào.",
  bindingOn: "đang bật",
  bindingOff: "đang tắt",
  bindingHistoryLater: "Lịch sử đổi gán (app nào dùng bộ nào, từ lúc nào) làm ở phase 2c của HQ-2026-013.",

  compareTitle: "So sánh hai phiên bản",
  compareFrom: "Từ",
  compareTo: "Đến",
  compareRun: "So sánh",
  comparing: "Đang so…",
  compareFailed: "Không so được: {error}",
  compareField: "Trường",
  compareOfficial: "giá trị chính thức của danh mục",
  compareNoHistory: "Bộ này mới có một phiên bản — chưa có gì để so.",
  compareSameRevision: "Chọn hai phiên bản khác nhau.",
  "same.true": "Giống",
  "same.false": "Đổi",
  "same.null": "Không so được",
  sameNullTitle: "Hub thiếu khoá giải mã hoặc bản mã hỏng — không biết hai giá trị có giống nhau không.",
  changed: "đổi",

  restore: "Khôi phục #{n}",
  restoreTitle: "Khôi phục phiên bản #{n}",
  restoreNext: "Bộ « {name} » sẽ có phiên bản MỚI #{next} chép nội dung của #{n}. Phiên bản hiện tại #{current} vẫn nằm trong lịch sử.",
  restoreApps: "Đang BẬT cho: {apps} ({env}) — app dùng nội dung mới từ lượt đọc cấu hình kế tiếp (app tự kéo cấu hình: ≤ 60 giây).",
  restoreNoApps: "Chưa bật cho app nào — chưa ảnh hưởng tin đi hay tin đến.",
  restoreUntested: "Bộ về « Chưa chạy thử »; gán đang bật vẫn bật. Nên chạy thử ngay sau khi khôi phục.",
  restoreGrace: "Nếu khôi phục đổi trường bí mật, khoá của phiên bản hiện tại #{current} còn được nhận thêm {hours} giờ cho tin đối tác đẩy tới.",
  restoreWaive: "Không giữ ân hạn cho khoá hiện tại (khoá này bị lộ)",
  reasonLabel: "Lý do (bắt buộc, 5–500 ký tự)",
  reasonPlaceholder: "vd « Dán nhầm Secret Key lúc 18:18 »",
  confirmRestore: "Khôi phục",
  restoring: "Đang khôi phục…",
  restored: "Đã khôi phục — phiên bản hiện hành là #{n}.",
  cancel: "Huỷ",
  failed: "Không thực hiện được.",

  versionAuthor: "{by} · {when}",
  summariesFailed: "Không tải được số phiên bản / ân hạn — vẫn lưu được, nhưng không kiểm được ai vừa sửa và không tự chạy thử sau khi lưu.",
  historyLink: "Lịch sử",
  graceBanner: "Khoá cũ của phiên bản {revisions} còn được gửi kèm cho app đang gán bộ này (chỉ để kiểm tin đối tác đẩy tới) đến {when}.",
  cutGrace: "Cắt ân hạn ngay",
  cutGraceTitle: "Cắt ân hạn — app thôi nhận MỌI khoá cũ của bộ này",
  cutGraceHint: "Dùng khi khoá cũ bị lộ. Hub đẩy cấu hình ngay; app tự kéo cấu hình thôi nhận khoá cũ trong ≤ 60 giây. Không hoàn tác được.",
  confirmCut: "Cắt ân hạn",
  cutting: "Đang cắt…",

  editGraceNotice:
    "Khoá mới áp NGAY cho lượt gọi đi. Khoá cũ còn được nhận thêm {hours} giờ cho tin đối tác đẩy tới — đổi khoá ở cổng đối tác SAU khi lưu ở đây. Bộ về « Chưa chạy thử ».",
  waiveGrace: "Khoá cũ bị lộ — không giữ ân hạn (app thôi nhận khoá cũ ngay)",
  noteLabel: "Ghi chú cho lịch sử (tuỳ chọn)",
  notePlaceholder: "vd « Đổi Secret Key theo yêu cầu của Tingee »",
  autoTestNotice: "Bộ đang BẬT cho app ở live — lưu xong, màn hình tự chạy thử khoá mới.",
  conflictHint: "Bộ vừa được lưu thành phiên bản #{n}. « Tải lại » mở lại form với nội dung mới nhất — phần vừa gõ (kể cả khoá) phải nhập lại.",

  autoTesting: "Đang tự chạy thử khoá mới…",
  autoTestPassed: "Khoá mới chạy thử ĐẠT.",
  autoTestFailed: "Khoá mới chạy thử KHÔNG ĐẠT — app đang dùng khoá này cho lượt gọi đi. Khoá cũ (phiên bản #{n}) còn được nhận cho tin đẩy tới đến {when}.",
  autoTestFailedNoGrace: "Khoá mới chạy thử KHÔNG ĐẠT — app đang dùng khoá này. Khôi phục phiên bản #{n} nếu dán nhầm khoá.",
  autoTestError: "Không tự chạy thử được: {error}. Bấm « Chạy thử » để thử lại.",
  autoRestoreNote: "Khoá mới chạy thử không đạt — quay lại phiên bản #{n}",
  dismiss: "Đóng",
} as const;
